<div class="dialog-padding">
  <h1 mat-dialog-title
      class="title-m">Continue Using Ark7 or Sign Out?</h1>
  <div class="body-m">
    <p>
      For security purposes, your session automatically times out after a period of inactivity. This prevents
      unauthorized access to your account.
    </p>
    <p>
      Click Continue to stay signed in.
    </p>
  </div>
  <div mat-dialog-actions>
    <div class="flex-row-between-center full-width">
      <div class="flex-scale"></div>
      <a7-button mat-dialog-close
                 (click)="continue()">
        Continue
      </a7-button>
    </div>
  </div>
</div>
